<div class="modal-body p-0 flex-fill d-flex flex-column compact-form" *ngIf="!!purchaseOrder">
    <div class="card">
        <div class="card-body pb-3">
            <div class="btn-toolbar mx-0 mb-0 mt-0">
                <div>
                    <button (click)="save()" class="btn btn-sm btn-primary me-2" *ngIf="hasChanges()">Save</button>
                    <button (click)="cancel()" class="btn btn-sm btn-success me-4" *ngIf="hasChanges()">Cancel</button>
                    <button (click)="close()" class="btn btn-sm btn-primary me-4" *ngIf="!hasChanges()">Close</button>
                    <ng-container *ngIf="!purchaseOrder.isReadOnly"> </ng-container>
                    <button *ngIf="!hasChanges()" (click)="print()" class="btn btn-sm btn-success me-2" [disabled]="hasChanges()" [hidden]="false">Print PO</button>
                    <button *ngIf="!hasChanges()" class="btn btn-sm btn-warning me-2" (click)="printAudit()" [hidden]="purchaseOrder.statusId != 3">Print Audit</button>
                    <button *ngIf="!hasChanges()" class="btn btn-sm btn-success me-2" (click)="email()">Email PO</button>
                    <button *ngIf="!hasChanges() && purchaseOrder.statusId !== 1" class="btn btn-sm btn-primary me-1" (click)="createPickup()">Create PickUp</button>
                </div>
                <div class="ms-auto d-flex align-items-center">
                    <ng-container>
                        <label class="mt-2 me-2">PO Number</label>
                        <dx-text-box class="me-3" [(value)]="purchaseOrder.pONumber" [readOnly]="false" width="125px"></dx-text-box>

                        <label class="mt-2 me-2">Order Date</label>
                        <dx-date-box class="me-3" [(value)]="purchaseOrder.pODate" width="125px"></dx-date-box>

                        <label class="mt-2 me-2">Est. Delivery Date</label>
                        <dx-date-box class="me-3" [(value)]="purchaseOrder.estimatedDelivery" width="125px"></dx-date-box>
                    </ng-container>

                    <label class="dx-box-item-content d-inline-block align-middle ms-2 me-2 mt-1">Status </label>
                    <h3>
                        <strong>{{ purchaseOrder.statusName }}</strong>
                    </h3>
                    <button class="btn btn-sm btn-warning ms-2" (click)="placeOrder()" [hidden]="purchaseOrder.statusId !== 1">Place Order</button>
                    <button class="btn btn-sm btn-primary ms-2" (click)="receive()" [hidden]="purchaseOrder.statusId !== 2">Receive</button>
                    <button class="btn btn-sm btn-success ms-2" (click)="receiveLine(true)" [hidden]="purchaseOrder.statusId !== 3">Receive In FULL</button>
                    <button class="btn btn-sm btn-success ms-2" (click)="complete()" [hidden]="purchaseOrder.statusId !== 3">Complete</button>
                    <button class="btn btn-sm btn-danger ms-2" (click)="complete(true)" [hidden]="purchaseOrder.statusId !== 4">UnComplete</button>
                    <button *ngIf="!hasChanges()" class="btn btn-sm btn-info ms-3" (click)="auditLog()">Audit Log</button>
                </div>
            </div>

            <dx-form *ngIf="purchaseOrder" [formData]="purchaseOrder" [colCount]="8">
                <dxi-item itemType="group" [colSpan]="2" [colCount]="1">
                    <dxi-item [label]="{ text: 'Vendor' }">
                        <div *dxTemplate>
                            <dx-select-box
                                [(value)]="purchaseOrder.vendorId"
                                [items]="vendors"
                                valueExpr="id"
                                displayExpr="companyName"
                                searchEnabled="true"
                                searchMode="startswith"
                                (onValueChanged)="vendorSelectionChanged($event)"
                                [readOnly]="readOnly"
                            ></dx-select-box>
                        </div>
                    </dxi-item>
                    <dxi-item>
                        <div *dxTemplate>
                            <h3 class="mt-0 mb-1">{{ purchaseOrder?.vendor?.companyName }}</h3>
                            <h3 class="mt-0 mb-1">{{ purchaseOrder?.vendor?.contactName }}</h3>
                            <div>{{ purchaseOrder?.vendor?.address1 }}</div>
                            <div>{{ purchaseOrder?.vendor?.address2 }}</div>
                            <div>
                                {{ purchaseOrder?.vendor?.city?.trim() }}{{ purchaseOrder?.vendor?.city && ', ' }}
                                {{ purchaseOrder?.vendor?.state }}
                                {{ purchaseOrder?.vendor?.postalCode }}
                                {{ purchaseOrder?.vendor?.country }}
                            </div>
                            <div>{{ purchaseOrder?.vendor?.phone }}</div>
                            <h4 *ngIf="purchaseOrder?.vendor?.accountNumber" class="mt-2 mb-0">Account # {{ purchaseOrder?.vendor?.accountNumber }}</h4>
                        </div>
                    </dxi-item>
                </dxi-item>

                <dxi-item itemType="group" [colSpan]="2" [colCount]="1">
                    <dxi-item [label]="{ text: 'ShipTo' }" *ngIf="purchaseOrder">
                        <div *dxTemplate>
                            <dx-select-box
                                [(value)]="purchaseOrder.shipToId"
                                [items]="shipAddresses"
                                valueExpr="id"
                                displayExpr="name"
                                searchEnabled="true"
                                (onValueChanged)="shipSelectionChanged($event)"
                                [readOnly]="readOnly"
                            ></dx-select-box>
                        </div>
                    </dxi-item>
                    <dxi-item>
                        <div *dxTemplate>
                            <h3 class="mt-0 mb-1">{{ selectedShipAddress?.name }}</h3>
                            <div>{{ selectedShipAddress?.address1 }}</div>
                            <div>
                                {{ selectedShipAddress?.city?.trim() }}{{ selectedShipAddress?.city && ', ' }}
                                {{ selectedShipAddress?.state }}
                                {{ selectedShipAddress?.zip }} {{ selectedShipAddress ? 'US' : '' }}
                            </div>
                        </div>
                    </dxi-item>
                </dxi-item>

                <dxi-item itemType="group" caption="Purchase Order Total" [colSpan]="2">
                    <dxi-item dataField="subTotal" editorType="dxNumberBox" [editorOptions]="{ format: '$#,##0.00', readOnly: true }"></dxi-item>
                    <dxi-item [label]="{ text: 'Freight' }" *ngIf="!purchaseOrder.isReadOnly" cssClass="input-right">
                        <div *dxTemplate>
                            <dx-number-box [(value)]="purchaseOrder.freight" format="$#,##0.00" (onValueChanged)="freightChange($event)"> </dx-number-box>
                        </div>
                    </dxi-item>
                    <dxi-item dataField="total" editorType="dxNumberBox" [editorOptions]="{ format: '$#,##0.00', readOnly: true }"></dxi-item>
                </dxi-item>

                <dxi-item itemType="group" caption="Attachments" [colSpan]="2" [colCount]="1">
                    <dxi-item>
                        <div *dxTemplate>
                            <ul style="list-style-type: none; padding-inline-start: 0px" *ngIf="attachments">
                                <li *ngFor="let attachment of attachments">
                                    <a title="remove" (click)="removeAttachment($event, attachment)"> <i class="fa fa-times" aria-hidden="true"></i> </a>&nbsp;
                                    <a title="view" (click)="openAttachment(attachment)">{{ attachment.name }}</a>
                                </li>
                            </ul>
                        </div>
                    </dxi-item>
                    <dxi-item>
                        <div *dxTemplate>
                            <dx-file-uploader
                                name="fileUpload"
                                selectButtonText="Select File(s)"
                                class="attachments"
                                accept="*"
                                uploadMode="instantly"
                                [showFileList]="false"
                                [multiple]="true"
                                [uploadUrl]="uploadUrl"
                                [uploadHeaders]="uploadHeader"
                                (onUploadStarted)="uploadStarted($event)"
                                (onUploadError)="uploadError($event)"
                                (onUploaded)="uploaded($event)"
                            >
                            </dx-file-uploader>
                        </div>
                    </dxi-item>
                </dxi-item>
            </dx-form>
        </div>
    </div>

    <div class="row" style="min-height: 300px">
        <div class="col-sm-6" style="padding-right: 0px">
            <div class="m-2">
                <dx-data-grid
                    *ngIf="purchaseOrderLines"
                    #linesGrid
                    height="400"
                    [dataSource]="purchaseOrderLines"
                    keyExpr="id"
                    [columnAutoWidth]="true"
                    (onToolbarPreparing)="onToolbarPreparing($event)"
                    (onSelectionChanged)="selectionChange($event)"
                    (onRowUpdated)="onRowUpdating($event)"
                    class="lines-grid"
                    [showBorders]="true"
                    [sorting]="'none'"
                >
                    <dxi-column dataField="lineNumber" [visible]="false" width="100" [sortIndex]="0" [sortOrder]="'asc'"></dxi-column>
                    <dxi-column dataField="quantity" [editorOptions]="{ step: 0 }" caption="Qty" [allowEditing]="purchaseOrder.statusId <= 3" width="65"></dxi-column>
                    <dxi-column dataField="partNumber" caption="Part #" [allowEditing]="false" width="180" cellTemplate="colorTemplate"></dxi-column>
                    <dxi-column dataField="part.revision" caption="Rev" width="50" [allowEditing]="false"></dxi-column>
                    <dxi-column dataField="mfgPartNumber" caption="Mfg Part #" [allowEditing]="false" width="100"></dxi-column>
                    <dxi-column dataField="description" caption="Description" [allowEditing]="false" width="230"></dxi-column>
                    <dxi-column dataField="purchaseOrderLineItemId" caption="Line Item" [allowEditing]="purchaseOrder.statusId !== 4" width="120">
                        <dxo-lookup [dataSource]="purchaseOrderLineItems" valueExpr="id" displayExpr="name"></dxo-lookup>
                    </dxi-column>
                    <dxi-column
                        dataField="qty"
                        [editorOptions]="{ step: 0 }"
                        [visible]="purchaseOrder.statusId >= 3"
                        caption="Edit"
                        [allowEditing]="purchaseOrder.statusId === 3"
                        width="65"
                    ></dxi-column>
                    <dxi-column dataField="quantityReceived" [visible]="purchaseOrder.statusId >= 3" [allowEditing]="false" caption="Received" width="65"></dxi-column>
                    <dxi-column dataField="quantityBackOrdered" [visible]="purchaseOrder.statusId >= 3" [allowEditing]="false" caption="BackOrdered" width="85"></dxi-column>
                    <dxi-column dataField="quantityOutstanding" [visible]="purchaseOrder.statusId >= 3" [allowEditing]="false" caption="Outstanding" width="85"></dxi-column>
                    <dxi-column
                        dataField="cost"
                        [editorOptions]="{ step: 0 }"
                        caption="Cost"
                        width="80"
                        [allowEditing]="purchaseOrder.statusId !== 4"
                        alignment="right"
                        [format]="{ type: 'currency', precision: 5 }"
                    ></dxi-column>

                    <dxi-column
                        dataField="lineTotal"
                        caption="Total"
                        width="90"
                        alignment="right"
                        [format]="{ type: 'currency', precision: 5 }"
                        [allowEditing]="false"
                    ></dxi-column>
                    <dxi-column dataField="note" caption="Note" width="150" [allowEditing]="purchaseOrder.statusId !== 4"></dxi-column>
                    <dxi-column dataField="partAliasId" width="100" [allowEditing]="false"></dxi-column>
                    <dxi-column dataField="packageQuantity" caption="Package Qty" width="100" [allowEditing]="false"></dxi-column>
                    <dxi-column width="100"></dxi-column>

                    <div *dxTemplate="let cell of 'colorTemplate'">
                        <div class="parent-part-number" *ngIf="cell.data.partId && !cell.data.parentLineId && !cell.data.isReplacement">{{ cell.text }}</div>
                        <div class="replacement-part-number" *ngIf="cell.data.isReplacement">{{ cell.text }}</div>
                        <div class="misc-part-number" *ngIf="!cell.data.partId && !cell.data.isReplacement">{{ cell.text }}</div>
                        <div class="option-part-number" *ngIf="cell.data.parentLineId">{{ cell.text }}</div>
                    </div>

                    <div *dxTemplate="let data of 'toolbarButtons'">
                        <button class="btn btn-sm btn-secondary me-2" (click)="addLines('Inventory')" [hidden]="purchaseOrder.statusId !== 1" [disabled]="!purchaseOrder.vendorId">
                            Add Part(s)
                        </button>
                        <button
                            class="btn btn-sm btn-secondary me-2"
                            (click)="addLinesFromAssemblyBOM()"
                            [hidden]="purchaseOrder.statusId !== 1"
                            [disabled]="!purchaseOrder.vendorId"
                        >
                            Add from Assembly BOM
                        </button>
                        <button class="btn btn-sm btn-secondary me-2" (click)="addMiscLine()" [hidden]="purchaseOrder.statusId !== 1" [disabled]="!purchaseOrder.vendorId">
                            Misc Line
                        </button>
                        <button
                            class="btn btn-sm btn-secondary me-2"
                            (click)="removeOrderLine()"
                            [disabled]="linesGrid.instance.getSelectedRowsData().length === 0 || purchaseOrder.statusId !== 1"
                            [hidden]="purchaseOrder.statusId !== 1"
                        >
                            Remove
                        </button>
                        <button
                            class="btn btn-sm btn-secondary me-4"
                            (click)="alphabetizeLines()"
                            [disabled]="purchaseOrder.statusId !== 1 || !purchaseOrder.vendorId"
                            [hidden]="purchaseOrder.statusId !== 1"
                        >
                            Alphabetize by Part #
                        </button>
                        <button
                            [accessKey]="'f'"
                            class="btn btn-sm btn-success me-4"
                            (click)="receiveLine(true, true)"
                            [disabled]="linesGrid.instance.getSelectedRowsData().length === 0"
                            [hidden]="purchaseOrder.statusId !== 3"
                        >
                            Receive Selected Line In Full
                        </button>
                        <button [accessKey]="'r'" class="btn btn-sm btn-success me-4" (click)="receiveLine()" [hidden]="purchaseOrder.statusId !== 3">Receive Edits</button>
                        <button class="btn btn-sm btn-primary me-4" (click)="markAsBackOrdered()" [hidden]="purchaseOrder.statusId !== 3">Mark As BackOrdered</button>
                    </div>
                    <div *dxTemplate="let data of 'toolbarText'">
                        <span class="me-3"
                            ><strong
                                >{{ linesGrid.instance.totalCount() + ' items' }}
                                {{ linesGrid.instance.getSelectedRowsData().length > 0 ? linesGrid.instance.getSelectedRowsData().length + ' selected' : '' }}
                            </strong></span
                        >
                    </div>
                    <dxo-selection [mode]="'multiple'"></dxo-selection>
                    <dxo-editing [mode]="'cell'" [allowUpdating]="!purchaseOrder.isReadOnly"></dxo-editing>
                    <dxo-state-storing [enabled]="true" [storageKey]="'purchase-order-detail-grid'"></dxo-state-storing>
                    <dxo-column-chooser [enabled]="false"></dxo-column-chooser>
                </dx-data-grid>
            </div>
        </div>

        <div class="col-sm-3" style="padding-left: 0px">
            <div class="m-1">
                <dx-data-grid
                    *ngIf="pickUps"
                    #pickUpsGrid
                    height="400"
                    keyExpr="id"
                    [dataSource]="pickUps"
                    [columnAutoWidth]="false"
                    (onToolbarPreparing)="onToolbarPreparing($event)"
                    [showBorders]="true"
                    [sorting]="'none'"
                >
                    <dxi-column dataField="purchaseOrderPickUp.id" caption="Id" width="50"></dxi-column>
                    <dxi-column dataField="quantity" caption="Qty" width="50"></dxi-column>
                    <dxi-column dataField="purchaseOrderLine.mfgPartNumber" caption="Part #" width="150"></dxi-column>
                    <dxi-column dataField="purchaseOrderPickUp.scheduledDate" caption="Date" width="150"></dxi-column>
                    <dxi-column dataField="completed" caption="Completed" width="150"></dxi-column>

                    <div *dxTemplate="let data of 'toolbarButtons'">
                        <button class="btn btn-sm btn-secondary me-2" (click)="printPickUp()" [disabled]="pickUpsGrid.instance.getSelectedRowsData().length === 0">Print</button>
                    </div>
                    <div *dxTemplate="let data of 'toolbarText'">
                        <span class="me-3"><strong>Scheduled PickUps</strong></span>
                    </div>
                    <dxo-selection [mode]="'single'"></dxo-selection>
                    <dxo-column-chooser [enabled]="false"></dxo-column-chooser>
                </dx-data-grid>
            </div>
        </div>

        <div class="col-sm-3" style="padding-left: 0px">
            <div class="m-1">
                <dx-data-grid
                    *ngIf="receivings"
                    #receivingGrid
                    height="400"
                    [dataSource]="receivings"
                    keyExpr="id"
                    [columnAutoWidth]="false"
                    (onToolbarPreparing)="onToolbarPreparing($event)"
                    [showBorders]="true"
                    [sorting]="'none'"
                >
                    <dxi-column dataField="quantity" caption="Qty Recd" width="100"></dxi-column>
                    <dxi-column dataField="created" caption="Date" width="100"></dxi-column>
                    <dxi-column dataField="createdBy.userName" caption="By" width="150"></dxi-column>

                    <div *dxTemplate="let data of 'toolbarButtons'">
                        <button
                            class="btn btn-sm btn-secondary me-2"
                            (click)="removeReceivingLine()"
                            [disabled]="receivingGrid.instance.getSelectedRowsData().length === 0 || purchaseOrder.statusId !== 3"
                        >
                            Remove
                        </button>
                    </div>
                    <div *dxTemplate="let data of 'toolbarText'">
                        <span class="me-3"><strong>Receivings</strong></span>
                    </div>
                    <dxo-selection [mode]="'single'"></dxo-selection>
                    <dxo-column-chooser [enabled]="false"></dxo-column-chooser>
                </dx-data-grid>
            </div>
        </div>
    </div>

    <div class="card">
        <div class="card-body">
            <dx-form #totalsForm [formData]="purchaseOrder" [colCount]="4" [readOnly]="readOnly">
                <dxi-item itemType="group" [colSpan]="2">
                    <dxi-item [label]="{ text: 'General Notes' }">
                        <div *dxTemplate>
                            <dx-text-area [(value)]="purchaseOrder.note" [height]="100"></dx-text-area>
                        </div>
                    </dxi-item>
                </dxi-item>
                <dxi-item itemType="group" [colSpan]="2">
                    <dxi-item [label]="{ text: 'Shipping Notes' }">
                        <div *dxTemplate class="d-flex align-items-start">
                            <dx-text-area [(value)]="purchaseOrder.shippingNote" [height]="100" class="flex-fill"></dx-text-area>
                        </div>
                    </dxi-item>
                </dxi-item>
            </dx-form>
        </div>
    </div>
</div>
